















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 't-input'
})
export default class Input extends Vue {
  @Prop({ type: String, default: () => 'text' }) type:
    | 'text'
    | 'number'
    | 'email'
    | 'password'
    | 'url'

  @Prop([String, Number]) value!: string | number

  @Emit('input')
  onInput(event) {
    return event.target.value
  }

  @Emit('change')
  onChange(event) {
    return event.target.value
  }
}
